import React, { useRef, useState, useLayoutEffect } from 'react'
import { Loading } from 'meinian-package/src/baseComponent'
import useContainerWidth from 'common/hooks/useContainerWidth'
import Scroll from '@yk-component/yk-scroll'
import styles from './index.module.less'

export default ({
  pageStart,
  pageSize,
  resultCount,
  loading = false,
  onInit,
  itemMinWidth,
  gridGap = 16,
  columnCount = 4,
  style,
  setItemWidth,
  children,
  loadingText = '加载中~',
}) => {
  const listRef = useRef(null)
  const width = useContainerWidth(listRef)
  const [span, setSpan] = useState(columnCount) // 每行显示的个数
  useLayoutEffect(() => {
    const count = Math.floor(width / itemMinWidth)
    if (count < columnCount) {
      const _itemWidth = width / columnCount
      setItemWidth?.(_itemWidth - gridGap)
      setSpan(columnCount)
    } else {
      const _itemWidth = width / count
      setItemWidth?.(_itemWidth - gridGap)
      setSpan(count)
    }
  }, [width])

  return <div ref={listRef} className={styles['card-list-wrap']}>
    <Scroll
      root={() => document.body}
      onEnd={() => {
        pageStart += pageSize
        if (pageStart < resultCount) {
          onInit?.(pageStart)
        }
      }}
      marginBottom={0}
      loading={loading}
      isEnd={false}
    >
      <div>
        {loading && pageStart === 0 ? <Loading spinning={loading} wrapperClassName="spin-transparent-bg"><div style={{ height: 400 }} /></Loading>
          : <div style={{ display: 'grid', gridGap, gridTemplateColumns: `repeat(${span}, 1fr)`, ...style }}>
            {children}
          </div>}
        {loading ? <div style={{ textAlign: 'center', color: 'var(--m-text-3)', padding: 32 }}>{loadingText}</div> : null}
      </div>
    </Scroll>
  </div>
}
